// Package Imports
import { Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Services
import { AuthorizationService } from '../../services/authorization/authorization.service';
import { ResourceService } from '../../services/resource/resource.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit {
  resources: any;
  status: string;

  constructor(resourceService: ResourceService,
              private readonly location: Location,
              private readonly route: ActivatedRoute,
              private readonly authService: AuthorizationService) {
    resourceService.getDictionary('unauthorized').subscribe((res) => {
      this.resources = res;
    });
  }

  ngOnInit(): void {
    this.status = this.route.snapshot.params.status;
  }

  navigateBack(): void {
    this.location.back();
  }
}
